module.exports = __webpack_public_path__ + "da61-img-hay-1.png";